import { Eye, Flower, Info, Phone, Search } from 'lucide-react'
import { Typography } from '@/components/ui/typography'
import { convertToNewThemeColors } from '@/lib/utils'

export default function ThemePreview({ colors, showTitle = true }) {
  const {
    background,
    foreground,
    primary,
    primary_foreground,
    secondary,
    secondary_foreground,
    accent,
    accent_foreground,
  } = convertToNewThemeColors(colors)

  return (
    <div className="space-y-4">
      {showTitle && (
        <Typography variant="h4" className="flex items-center gap-2">
          <Eye />
          Color Preview
        </Typography>
      )}
      <div
        className="border rounded-lg overflow-hidden"
        style={{
          backgroundColor: background,
          color: foreground,
        }}
      >
        {/* Info Header Bar */}
        <div
          className="py-2"
          style={{
            backgroundColor: primary,
            color: primary_foreground,
          }}
        >
          <div className="flex items-center justify-between gap-4 text-sm px-6">
            <div className="flex items-center gap-1" style={{ color: `${primary_foreground}` }}>
              <Phone className="h-3 w-3" />
              <span className="font-medium">(555) 123-4567</span>
            </div>
            <div className="flex items-center gap-1" style={{ color: `${primary_foreground}` }}>
              <Info className="h-3 w-3" />
              <span>About Us</span>
            </div>
          </div>
        </div>

        {/* Header with org name and navigation */}
        <div
          className="px-6 py-4"
          style={{
            backgroundColor: secondary,
            color: secondary_foreground,
          }}
        >
          <div className="flex items-center justify-between gap-2">
            <h1
              className="text-lg sm:text-xl font-bold"
              style={{
                color: secondary_foreground,
              }}
            >
              Your Logo
            </h1>
            <nav className="flex gap-3 md:gap-6">
              <span className="text-sm cursor-pointer hover:opacity-75">Shop</span>
              <span className="text-sm cursor-pointer hover:opacity-75">About</span>
              <span className="text-sm cursor-pointer hover:opacity-75">Contact</span>
              <span className="text-sm cursor-pointer hover:opacity-75">Cart</span>
            </nav>
          </div>
        </div>

        {/* Search Bar */}
        <div
          className="px-6 py-2 border-b"
          style={{
            borderColor: `${foreground}20`,
          }}
        >
          <div className="max-w-md">
            <div className="relative flex items-center gap-2">
              <div className="relative flex-1">
                <Search
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4"
                  style={{
                    color: `${secondary_foreground}60`,
                  }}
                />
                <input
                  type="text"
                  placeholder="Search Catalog"
                  className="w-full pl-8 pr-4 py-1 sm:py-2 border rounded-md"
                  style={{
                    backgroundColor: secondary,
                    borderColor: `${foreground}20`,
                    color: secondary_foreground,
                  }}
                />
              </div>
              <button
                data-raw-button-owner="storefront-simulation"
                className="px-4 py-2 rounded-md text-sm font-medium"
                style={{
                  backgroundColor: primary,
                  color: primary_foreground,
                }}
              >
                Search
              </button>
            </div>
          </div>
        </div>

        {/* Main content area */}
        <div className="py-2 px-6 space-y-6">
          <div>
            <h2 className="text-lg font-semibold mb-2">Featured Products</h2>

            {/* Product cards */}
            <div className="grid grid-cols-2 gap-4">
              {/* Product 1 the price should be in the bottom right corner of the card */}

              {[1, 2].map((product) => (
                <div key={product}>
                  <div className="relative flex aspect-square flex-col items-center justify-center rounded-md bg-muted">
                    <Flower className="size-6 text-muted-foreground/65 sm:size-8" />
                    <span className="text-center" style={{ color: foreground }}>
                      Your image
                    </span>
                    <div
                      className="text-center absolute rounded-md p-1 sm:p-2 bottom-1 right-1 sm:bottom-3 sm:right-3"
                      style={{
                        backgroundColor: accent,
                        color: accent_foreground,
                      }}
                    >
                      <p className="text-xs sm:text-sm" style={{ color: accent_foreground }}>
                        $62.50
                      </p>
                    </div>
                  </div>
                  <div className="text-center">
                    <h3 className="font-medium text-sm" style={{ color: foreground }}>
                      Product {product}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          className="px-6 py-4 "
          style={{
            backgroundColor: primary,
            color: primary_foreground,
          }}
        >
          <div className="text-center space-y-2">
            <h3 className="font-semibold text-lg">Store Name</h3>
            <p className="text-sm opacity-90">123 Main Street, Your City, State 12345</p>
            <p className="text-sm opacity-90">© 2024 Your Store Name. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  )
}
